import AsidePhotos from './AsidePhotos'

export default AsidePhotos
